import { createContext, useContext } from 'react';
import type { LoginPromptId } from './registry';

export interface LoginPromptApi {
    grantedId: LoginPromptId | null;
    /** A tour or an order-page rating dialog is on screen. The queue waits. */
    shopOverlayHeld: boolean;
    reportWaiting: (id: LoginPromptId, waiting: boolean) => void;
    claim: (id: LoginPromptId) => void;
    /** Prompt closed before it counted as finished (tour abort). Does not start the gap. */
    releaseClaim: () => void;
    /** Shopper finished the granted prompt. Starts the gap. Does not open the next one. */
    settle: () => void;
    /** Order-page rating closed. Starts the gap without clearing a different grant. */
    stampClosed: () => void;
    holdOverlay: (token: string) => void;
    releaseOverlay: (token: string) => void;
    /** Shopper asked for this prompt (notification deep link). May open during the gap, never over another prompt. */
    requestInterrupt: (id: LoginPromptId) => void;
    getGrantedId: () => LoginPromptId | null;
}

export const LoginPromptContext = createContext<LoginPromptApi | null>(null);

export function useLoginPrompt(): LoginPromptApi {
    const ctx = useContext(LoginPromptContext);
    if (!ctx) throw new Error('useLoginPrompt must be used within LoginPromptProvider');
    return ctx;
}
